import SodRemediateImpactSummary from './SodRemediateImpactSummary';

export default SodRemediateImpactSummary;
